import { module } from 'modujs'
import { CUSTOM_EVENT, ENV, FONT } from '../config'
import { whenReady } from '../utils/fonts'
import { gsap, SplitText } from '../lib/gsap'

export default class extends module {

    constructor(m) {
        super(m)

        this.$el = this.el
        this.$text = this.$('text')[0]
    }

    init() {

        if(ENV.REDUCED_MOTION) {
            return
        }

        whenReady(FONT.EAGER).then(() => {
            // Split lines
            this.initSplits()

            // Resize event
            window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.resizeBind = () => this.resize())
        })
    }

    initSplits() {

        // Split text
        this.split = new SplitText(this.$text, {
            type: 'words, chars',
        })

        this.split.chars.forEach(char => {
            gsap.set(char, { willChange: 'opacity' })
        })

        this.tl = gsap.timeline({
            paused: true,
            defaults: {
                duration: 1,
                ease: 'none',
            },
        })

        this.tl.from(this.split.chars, {
            opacity: 0.3,
            stagger: 0.1,
        })
    }

    revertSplits() {
        this.split?.revert()

        this.tl.kill()
    }

    resize() {
        this.revertSplits()
        this.initSplits()
    }

    onScrollProgress(progress) {
        this.tl?.progress?.(progress || 0)
    }

    destroy() {

        if(ENV.REDUCED_MOTION) {
            return
        }

        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.resizeBind)
    }
}
